import { format } from 'date-fns';
import { sv } from 'date-fns/locale';
const NewsItemModal = ({ content, author, timestamp, onClose }) => {
	const formattedTimestamp = format(
		new Date(timestamp),
		"d MMMM yyyy 'kl.' HH:mm",
		{ locale: sv }
	);

	return (
		<div className="modal-backdrop">
			<div className="modal-content">
				<button onClick={onClose} className="close-button">
					X
				</button>
				<div className="modal-bodys">
					<p>{content}</p>
				</div>
				<div className="modal-footers">
					<strong>Publicerad av: </strong>
					{author}
				</div>
				<div className="modal-footers">
					<strong>Tid:</strong> {formattedTimestamp}
				</div>
			</div>
		</div>
	);
};

export default NewsItemModal;
